//import React from 'react';
import React, {useRef, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useGSAP } from "@gsap/react";
import '../navigation.js';
import { gsap } from 'gsap';
import audiotrack from '../audio/leberch-space-ambient-509783.mp3';


// Get Images
import logo from '../images/logo.svg'; // get images

const Header = () => {


  const nav_code = useRef();

  useGSAP(() => {


 }, { scope: nav_code });










  return (
    <div className="site-header-wrapper">
    <header className="site-header">

       

      <div className="brand-logo"> 
      <NavLink className={({ isActive }) => isActive ? 'nav-highlight' : ''} to="/" end>
    


 <svg className="logo" id="mhd-nav-logo" className="screen-mhd-logo" version="1.1" viewBox="0 0 223.2 152.8"> 
  <polygon id="site-logo-stripe-5" points="200 105.6 200 128 177.7 128 152.8 152.8 191.3 152.8 223.2 120.9 223.2 82.4 200 105.6"/>
  <g id="site-logo-stripe-4">
    <polygon points="156.7 85.5 156.7 118.5 173.2 102.1 173.2 85.5 156.7 85.5"/>
    <polygon points="223.2 13.6 200 36.8 200 75.2 223.2 52.1 223.2 13.6"/>
    <polygon points="129.9 106.9 123.8 113 123.8 128 108.8 128 83.9 152.8 122.4 152.8 147.3 128 129.9 128 129.9 106.9"/>
  </g>
  <g id="site-logo-stripe-3">
      <polygon points="129.9 38.1 123.8 44.2 123.8 82.6 129.9 76.5 129.9 38.1"/>
      <polygon points="156.7 24.9 156.7 49.7 173.2 33.2 173.2 24.9 181.5 24.9 206.4 0 167.9 0 143 24.9 156.7 24.9"/>
      <polygon points="64.8 128 60.9 107.1 50.2 117.8 50.2 128 40 128 15.1 152.8 53.6 152.8 78.5 128 64.8 128"/>
  </g>
  <g id="site-logo-stripe-2">
    <polygon points="70.9 66.7 79.5 58.1 85.4 24.9 112.7 24.9 137.6 0 99.1 0 65.1 34 70.9 66.7"/>
    <polygon points="25.1 74 0 99.1 0 137.5 25.1 112.5 25.1 74"/>
    <polygon points="56.1 81.5 50.5 51.2 50.2 51.2 50.2 87.4 56.1 81.5"/>
  </g>
  <polygon id="site-logo-stripe-1" points="25.1 24.9 43.8 24.9 68.7 0 30.2 0 0 30.2 0 68.7 25.1 43.7 25.1 24.9"/>
  <path id="site-logo-initials-bg" d="M20.1,19.8v113.1h184.8V19.8H20.1ZM123.8,128h-25.1V51.2h-.3l-14.3,76.8h-19.3l-14.3-76.8h-.3v76.8h-25.1V24.9h38.4l10.8,61.1h.3l10.8-61.1h38.4v103.1h0ZM200,128h-26.8v-42.5h-16.5v42.4h-26.8V24.9h26.8v37.8h16.5V24.9h26.8v103.1Z"/>
</svg>



      </NavLink>
      </div>

     <nav className="site-nav" id="site-nav" aria-label="Main Site Navigation" aria-labelledby="menubutton">
      <ul id="site-nav-menu" className="site-nav-menu" data-visibility="hidden">
       <li>
        <NavLink to="/">Home</NavLink>
        </li>
        <li>
        <NavLink to="/portfolio">Portfolio</NavLink>
        </li>
        <li>
        <NavLink to="/services">Services</NavLink>
        </li>
          <li>
        <NavLink to="/profile">Profile</NavLink>
        </li>
        <li>
        <NavLink to="/contact">Contact</NavLink>
        </li>
     </ul>
     <button onClick={showMenu} className="menubutton" aria-label="Menu" aria-haspopup="true" aria-controls="site-nav" aria-expanded="false">

       <span className="menu-top-bar"></span>
       <span className="menu-middle-bar"></span>
       <span className="menu-bottom-bar"></span>

     </button>
     </nav>


          <div className="dyn-background"></div>

    </header>

	
	
</div>



  );









};

export default Header;




// MENU NAVIGATION TOGGLE SCRIPT
// ================================= //



const showMenu = (e) => {
   e.preventDefault();
   e.stopPropagation();

   const menutl = gsap.timeline({}); 
   

    //let checkval = mmenu.style.top.value;
    //console.log(checkval);
     const mmenu = document.querySelector(".site-nav-menu");
     const mbutton = document.querySelector(".menubutton");
     const menuflag = mmenu.getAttribute('data-visibility'); 

     mmenu.addEventListener("click", menuHideOnClick);

 

      
    



    function menuHideOnClick() {


           mmenu.setAttribute('data-visibility', "hidden");
           menutl.to(".site-nav-menu", {top: "-500px", duration: 1, ease: "power4.out" });
           // menu button state = open
           gsap.to(".menu-middle-bar", {duration:0.25, opacity:1});
          gsap.to(".menu-top-bar", {duration:0.25, y:"0px", rotate:0});
          gsap.to(".menu-bottom-bar", {duration:0.25, y:"0px", rotate:-0});
          gsap.to(".dyn-background", {duration:0.25, height:"100px",});
            }

    if (menuflag == "hidden") {
        // toggle = show menu
        mmenu.setAttribute('data-visibility', "shown");
        menutl.to(".site-nav-menu", {top: "275px", duration: 1, ease: "power4.out" });
        // menu button state = close
        // ANIMATE HAMBURGER TO -  ( X )
            gsap.to(".menu-middle-bar", {duration:0.25, opacity:0});
            gsap.to(".menu-top-bar", {duration:0.25, y:"24px", rotate:45});
            gsap.to(".menu-bottom-bar", {duration:0.25, y:"-24px", rotate:-45});

            gsap.to(".dyn-background", {duration:1, height:"100dvh",});
           //  Extend the background as a menu - hack.

           document.querySelector('.dyn-background').classList.remove("fade-bg-out");
          document.querySelector('.dyn-background').classList.add("fade-bg-in");

      } else if (menuflag == "shown"){
        // toggle = hide menu
        mmenu.setAttribute('data-visibility', "hidden");
        menutl.to(".site-nav-menu", {top: "-500px", duration: 1, ease: "power4.out" });
       // menu button state = open
       // ANIMATE HAMBURGER TO -  ( = )
        
          gsap.to(".menu-middle-bar", {duration:0.25, opacity:1});
          gsap.to(".menu-top-bar", {duration:0.25, y:"0px", rotate:0});
          gsap.to(".menu-bottom-bar", {duration:0.25, y:"0px", rotate:-0});

           gsap.to(".dyn-background", {duration:0.25, height:"100px",});
          //document.querySelector('.dyn-background').classList.remove("fade-bg-in");
          //document.querySelector('.dyn-background').classList.add("fade-bg-out");
      }

   
      


      
 }

 